import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fivezeroseaterbusonrentinpune() {



  const cardData = {
"keyword": "50 Seater Bus On Rent in Pune",

"headingDescription":
  "Aaradhya Travels provides reliable 50 Seater Bus On Rent in Pune for large group travel including corporate tours, weddings, school and college trips, pilgrimage journeys, industrial visits, and long outstation vacations. Our spacious AC buses with pushback seats, wide interiors, and experienced drivers ensure safe, comfortable, and affordable transportation for big groups across Pune and Maharashtra.",

"topPlaces": [

{
"title": "Bhandardara",
"description":
"Bhandardara is a beautiful hill station known for Arthur Lake, Randha Falls, and lush green valleys. It is a peaceful weekend getaway from Pune, popular for group tours and nature trips using 32 seater buses."
},
{
"title": "Kaas Plateau",
"description":
"Kaas Plateau, also called the Valley of Flowers of Maharashtra, is a UNESCO World Heritage site famous for seasonal wildflowers and biodiversity. It is a popular monsoon tourism destination for group travel from Pune."
},
{
"title": "Amboli",
"description":
"Amboli is a scenic hill station in the Sahyadri range known for waterfalls, misty valleys, and monsoon beauty. It is widely chosen for long group trips and nature tours from Pune using 32 seater buses."
},
{
"title": "Shani Shingnapur",
"description":
"Shani Shingnapur is a famous pilgrimage village known for the Shani Temple where Lord Shani is worshipped. It is a highly visited spiritual destination from Pune, often preferred by group travelers using 32 seater buses for comfortable temple darshan and religious tours."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular stop for long-distance group travel and leisure tours from Pune."
},
{
"title": "Dapoli",
"description":
"Dapoli is a peaceful coastal destination known for clean beaches, dolphin spotting, and calm surroundings. It is ideal for family and group tours from Pune using 32 seater buses."
},
{
"title": "Murud-Janjira",
"description":
"Murud-Janjira is famous for its sea fort located on an island, attracting history lovers and tourists. It is a popular coastal sightseeing destination for group tours from Pune."
},
{
"title": "Tamhini Ghat",
"description":
"Tamhini Ghat is a scenic monsoon destination known for waterfalls, foggy mountains, and lush greenery. It is one of the most popular short road trips from Pune for group travel."
},
{
"title": "Pawna Lake",
"description":
"Pawna Lake is a popular camping and weekend getaway spot near Lonavala known for lakeside tents, bonfires, and sunset views. It is widely chosen for group camping trips from Pune."
},
{
"title": "Ratnagiri",
"description":
"Ratnagiri is a coastal Konkan destination known for beaches, forts, Alphonso mangoes, and long scenic road trips. It is a popular long-distance group travel destination from Pune."
}
],



services: [
  {
    name: "50 Seater Bus Per KM Rate in Pune",
    description: "50 seater bus per km rate in Pune service provides transparent and affordable transportation solutions for local travel, outstation journeys, airport transfers, corporate outings, and tourist group travel. Spacious seating and luggage space ensure smooth highway travel suitable for large passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 50 seater bus reservations."
  },
  {
    name: "Bus on Rent in Pimpri Chinchwad",
    description: "Bus on rent in Pimpri Chinchwad service offers reliable transportation for family functions, educational tours, airport transfers, office outings, and outstation travel from Pimpri Chinchwad Pune. Spacious buses ensure comfortable seating and smooth travel experiences suitable for all passenger groups. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across Pimpri Chinchwad Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "50 Seater Bus on Rent Hadapsar",
    description: "50 seater bus on rent Hadapsar service provides dependable transportation for wedding travel, educational tours, family outings, airport transfers, and corporate events from Hadapsar Pune. Spacious interiors and comfortable seating ensure pleasant travel experiences suitable for local and outstation journeys. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Hadapsar Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "50 Seater Coach Hire Prices",
    description: "50 seater coach hire prices service offers affordable and comfortable transportation for family vacations, business travel, tourist tours, school outings, and outstation journeys. Spacious coaches ensure smooth highway travel suitable for large passenger groups and sightseeing requirements. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient coach hire reservations."
  },
  {
    name: "50 Seater Bus Rent Price",
    description: "50 seater bus rent price service provides economical transportation solutions for airport transfers, corporate events, educational trips, family tours, and group travel requirements. Spacious buses ensure comfortable seating and smooth journeys suitable for long-distance and local travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient bus rental reservations."
  },
  {
    name: "50 Seater Coach Bus Hire in Pune",
    description: "50 seater coach bus hire in Pune service offers premium transportation for corporate travel, weddings, educational tours, sightseeing journeys, and outstation group travel. Spacious seating and luggage capacity ensure pleasant travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient coach bus reservations."
  },
  {
    name: "50 Seater Bus Hire in Kharadi",
    description: "50 seater bus hire in Kharadi service provides reliable transportation for airport transfers, office outings, educational tours, wedding travel, and outstation journeys from Kharadi Pune. Spacious buses ensure comfortable seating and smooth travel experiences suitable for large passenger groups. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, IT parks, and commercial areas across Kharadi Pune. Flexible booking options allow convenient bus hire reservations."
  },
  {
    name: "50 Seater AC Bus Per KM Rate",
    description: "50 seater AC bus per km rate service offers premium air-conditioned transportation for business travel, family vacations, corporate outings, airport transfers, and tourist journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient AC bus reservations."
  },
  {
    name: "Hire 50 Seater Bus on Rent",
    description: "Hire 50 seater bus on rent service provides spacious and comfortable transportation for weddings, sightseeing tours, educational trips, pilgrimage travel, and outstation journeys. Spacious interiors and luggage capacity ensure smooth travel experiences suitable for large passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient 50 seater bus reservations."
  },
  {
    name: "50 Seater Bus for Hire for Outstation from Pune",
    description: "50 seater bus for hire for outstation from Pune service offers dependable long-distance transportation for Goa trips, Konkan Darshan, Mahabaleshwar tours, pilgrimage journeys, and tourist travel. Spacious seating and smooth highway performance ensure comfortable journeys suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation bus reservations."
  },
  {
    name: "50 Seater Bus on Rent for Outstation",
    description: "50 seater bus on rent for outstation service provides comfortable transportation for family vacations, office outings, educational tours, religious travel, and sightseeing journeys from Pune. Spacious seating and luggage capacity ensure smooth highway travel suitable for large travel groups. Professional drivers ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation bus reservations."
  },
  {
    name: "50 Seater Bus for Wedding in Pune",
    description: "50 seater bus for wedding in Pune service offers luxurious transportation for marriage ceremonies, bridal parties, family gatherings, and wedding guest travel requirements. Spacious seating and elegant interiors ensure smooth travel experiences suitable for wedding celebrations and event transportation. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "50 Seater Bus on Rent for Corporate Picnic",
    description: "50 seater bus on rent for corporate picnic service provides dependable transportation for office outings, employee recreation trips, company picnics, and team-building activities. Spacious buses ensure comfortable travel experiences suitable for large corporate groups and business teams. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, and commercial areas across Pune. Flexible booking options allow convenient corporate picnic bus reservations."
  },
  {
    name: "50 Seater Bus on Rent for Corporate Event",
    description: "50 seater bus on rent for corporate event service offers professional transportation for conferences, business meetings, exhibitions, seminars, and office functions. Spacious seating and smooth travel performance ensure pleasant journeys suitable for executive teams and office staff. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial locations across Pune. Flexible booking options allow convenient corporate event bus reservations."
  },
  {
    name: "50 Seater Bus on Rent in Viman Nagar",
    description: "50 seater bus on rent in Viman Nagar service provides reliable transportation for airport transfers, office travel, educational tours, family functions, and outstation journeys from Viman Nagar Pune. Spacious buses ensure comfortable seating and smooth travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, Pune Airport, and commercial locations across Viman Nagar Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "50 Seater Bus on Rent for Ashtavinayak Darshan",
    description: "50 seater bus on rent for Ashtavinayak Darshan service offers comfortable transportation for Ganpati temple tours, pilgrimage journeys, family darshan trips, and spiritual group travel from Pune. Spacious seating and smooth highway travel ensure pleasant journeys suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the temple circuit route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ashtavinayak bus reservations."
  },
  {
    name: "50 Seater Bus on Rent for Jyotirlinga Darshan",
    description: "50 seater bus on rent for Jyotirlinga Darshan service provides reliable transportation for devotees visiting sacred Jyotirlinga temples across Maharashtra and nearby regions. Spacious buses ensure comfortable seating and smooth long-distance travel suitable for pilgrimage groups and spiritual tours. Professional drivers ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Jyotirlinga bus reservations."
  },
  {
    name: "50 Seater Bus for School Picnic",
    description: "50 seater bus for school picnic service offers safe and spacious transportation for educational tours, school outings, student travel, and picnic journeys. Comfortable seating and smooth highway performance ensure pleasant travel experiences suitable for students, teachers, and educational groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from schools, colleges, coaching institutes, homes, and educational campuses across Pune. Flexible booking options allow convenient school picnic bus reservations."
  },
  {
    name: "50 Seater Bus for Family Tour",
    description: "50 seater bus for family tour service provides comfortable transportation for holiday vacations, sightseeing trips, pilgrimage journeys, and group travel with relatives and family members. Spacious seating and luggage capacity ensure smooth travel experiences suitable for long-distance and local tours. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential areas across Pune. Flexible booking options allow convenient family tour bus reservations."
  },
  {
    name: "50 Seater Bus for Airport Transfer",
    description: "50 seater bus for airport transfer service offers dependable transportation for tourist groups, corporate teams, wedding guests, and family passengers traveling to and from airport terminals. Spacious buses ensure comfortable luggage handling and smooth airport journeys suitable for large passenger groups. Professional chauffeurs ensure timely pickups and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport bus reservations."
  },
  {
    name: "50 Seater Bus for Corporate Travel",
    description: "50 seater bus for corporate travel service provides professional transportation for employee movement, industrial visits, office meetings, conferences, and executive travel requirements. Spacious seating and smooth highway performance ensure comfortable journeys suitable for corporate teams and office staff. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient corporate travel bus reservations."
  },
  {
    name: "50 Seater Bus for Group Tour",
    description: "50 seater bus for group tour service offers spacious transportation for sightseeing journeys, tourist travel, educational tours, pilgrimage trips, and family vacations from Pune. Comfortable seating and luggage space ensure smooth highway journeys suitable for large travel groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient group tour bus reservations."
  }
],

tableData: [
  ["50 Seater Bus Per KM Rate in Pune", "Bus on Rent in Pimpri Chinchwad"],
  ["50 Seater Bus on Rent Hadapsar", "50 Seater Coach Hire Prices"],
  ["50 Seater Bus Rent Price", "50 Seater Coach Bus Hire in Pune"],
  ["50 Seater Bus Hire in Kharadi", "50 Seater AC Bus Per KM Rate"],
  ["Hire 50 Seater Bus on Rent", "50 Seater Bus for Hire for Outstation from Pune"],
  ["50 Seater Bus on Rent for Outstation", "50 Seater Bus for Wedding in Pune"],
  ["50 Seater Bus on Rent for Corporate Picnic", "50 Seater Bus on Rent for Corporate Event"],
  ["50 Seater Bus on Rent in Viman Nagar", "50 Seater Bus on Rent for Ashtavinayak Darshan"],
  ["50 Seater Bus on Rent for Jyotirlinga Darshan", "50 Seater Bus for School Picnic"],
  ["50 Seater Bus for Family Tour", "50 Seater Bus for Airport Transfer"],
  ["50 Seater Bus for Corporate Travel", "50 Seater Bus for Group Tour"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 50 Seater Bus On Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable 50 seater bus rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate events, school tours, weddings, and large group travel."
      },
      {
        WhyChooseheading: "Affordable 50 Seater Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable 50 seater bus on rent in Pune with transparent pricing, flexible booking plans, and complete travel assistance without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Bus Booking Service in Pune",
        WhyChoosedescription: "Our 50 seater bus rental service in Pune operates 24 hours for airport transfers, employee transportation, educational tours, pilgrimage journeys, family functions, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC 50 Seater Buses",
        WhyChoosedescription: "All 50 seater buses provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained to provide safe and comfortable travel experiences for large groups."
      },
      {
        WhyChooseheading: "Customized One Day & Multi-Day Tours",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day tours, weekend trips, multi-day outstation journeys, and flexible travel packages according to customer travel requirements."
      },
      {
        WhyChooseheading: "Ideal for Large Group & Corporate Travel",
        WhyChoosedescription: "The 50 seater bus is ideal for corporate teams, school and college groups, wedding guest transportation, tourist groups, industrial visits, and family vacations from Pune."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from Pune Airport, railway stations, hotels, homes, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Long Distance Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is 50 seater bus on rent in Pune?", answer: "50 seater bus rental service in Pune provides comfortable group transportation for corporate travel, school tours, weddings, family trips, and outstation journeys." },
    { question: "Is 50 seater bus booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 50 seater bus rental service in Pune." },
    { question: "Can I book 50 seater bus for outstation travel?", answer: "Yes, customers can book 50 seater buses for outstation tours, pilgrimage journeys, hill station trips, and holiday travel." },
    { question: "Do you provide 50 seater buses for corporate events?", answer: "Yes, Aaradhya Travels provides 50 seater bus rental service for corporate meetings, office outings, conferences, and employee transportation." },
    { question: "Are all 50 seater buses air-conditioned?", answer: "Yes, all 50 seater buses are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book 50 seater bus online in Pune?", answer: "Yes, customers can easily book 50 seater bus rental service online or through phone booking." },
    { question: "Do you provide buses for weddings and educational tours?", answer: "Yes, Aaradhya Travels provides spacious 50 seater buses suitable for weddings, school trips, college tours, and family travel." },
    { question: "Are 50 seater bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for 50 seater bus rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." },
    { question: "Do you provide pickup from Pune Airport and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Jadhav",
    feedback:
      "We hired a 50 Seater bus on rent in Pune for our industrial visit, and the arrangement worked out perfectly. The bus was spacious, comfortable, and ideal for managing such a large group.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Monika Deshmukh",
    feedback:
      "A 50 Seater bus rental in Pune helped us organize transportation for a big family function very smoothly. The journey was comfortable, and everyone appreciated the seating and cleanliness.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "50 Seater Bus On Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/50-seater-bus-on-rent-pune.jpg",
  "description": "Book 50 Seater Bus on rent in Pune with Aaradhya Travels for weddings, corporate events, school trips, outstation travel, airport transfers, and group tours. Affordable AC 50 seater coach available across Pune, Pimpri Chinchwad, Hadapsar, and Kharadi.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2487"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/50-seater-bus-on-rent-in-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>
    50 Seater Bus On Rent in Pune | AC Coach Hire for Outstation | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 50 Seater Bus on rent in Pune with Aaradhya Travels. Affordable AC coach available for outstation trips, weddings, corporate travel, school tours, airport transfers, Pimpri Chinchwad, Hadapsar, Kharadi, and group bookings."
  />

  <meta
    name="keywords"
    content="50 Seater Bus per km rate in Pune, Bus on rent in Pimpri Chinchwad, 50 Seater bus on Rent Hadapsar, 50 seater coach hire prices, 50 seater bus rent price, 50 seater coach Bus Hire in Pune, 50 Seater bus hire in Kharadi, 50 Seater ac bus per km rate, Hire 50 seater bus on Rent, 50 seater bus for hire for outstation from Pune, 50 Seater bus on rent for outstation, 50 seater bus for wedding in Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fivezeroseaterbusonrentinpune;